import { getMarketplaceSearchClient } from 'marketplace-ui-common/clients/marketplaceSearchClient';
export const marketplaceAppSearch = ({
  appContext = 'app'
}, {
  language,
  queries,
  showPreferredLanguageFirst = false
}, opts = {}) => {
  const client = getMarketplaceSearchClient(appContext);
  return client.post('apps/search', Object.assign({}, opts, {
    data: {
      language,
      showPreferredLanguageFirst,
      queries
    }
  }));
};